
  var _styles = {
  "bottom-slider-modal": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "zIndex": 2,
    "height": "100%"
  },
  "bottom-slider-modal__header": {
    "position": "relative",
    "textAlign": "center",
    "height": "1.46667rem",
    "paddingTop": "0.53333rem",
    "paddingBottom": "0.13333rem"
  },
  "bottom-slider-modal__title": {
    "width": "100%",
    "height": "100%",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "lineHeight": "0.53333rem",
    "textAlign": "center"
  },
  "bottom-slider-modal__close-btn": {
    "position": "absolute",
    "top": "0.21333rem",
    "right": "0.13333rem",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0
  },
  "bottom-slider-modal__content": {
    "flex": 1
  }
};



  module.exports = _styles;
  